module.exports = __webpack_public_path__ + "img/108.1846b433.svg";